"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurveSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.CurveSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('curve'),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    cpa: XYPosition_1.XYPositionSchema,
    cpb: XYPosition_1.XYPositionSchema,
    width: zod_1.z.number(),
});
//# sourceMappingURL=Curve.js.map